import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CopyOutlined } from '@ant-design/icons';
import { Col, Form, Select, Tooltip, message } from 'antd';
import { useState } from 'react';
import './FormSelect.scss';
import { simpleSearchFilter } from '../../../utils';
export const FormSelect = ({ name, label = '', isRequired = false, readOnly = false, allowClear = true, placeholder, rules = [], hidden = false, isRow = false, className = '', col = 24, responsive = undefined, options, isMultiSelect = false, returnValueType = 'id', onChange, popupMatchSelectWidth = 400, isError = false, errorMessage = '', isCopy = false, style, ...props }) => {
    const validationRules = [
        ...(isRequired ? [{ required: true, message: `Trường ${label ?? 'này'} không được để trống!` }] : []),
        ...rules
    ];
    const colProps = responsive ?? { xs: col, sm: col, md: col, lg: col, xl: col, xxl: col };
    // Controlled open state when caller doesn't control open prop
    const [openState, setOpenState] = useState(undefined);
    // Extract possible open passed in props to avoid clobbering them
    const { open: openProp, ...rest } = props;
    const handleSelectChange = (value, option) => {
        if (returnValueType === 'object') {
            onChange?.(option, option);
        }
        else {
            onChange?.(value, option);
        }
    };
    const handleDropdownVisibleChange = (isOpen) => {
        setOpenState(isOpen);
    };
    const handleCopy = (text) => {
        navigator.clipboard.writeText(text);
        message.success(`Đã copy "${text}"`);
    };
    const renderLabelWithCopy = (text) => (_jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: 6 }, children: [_jsx("span", { style: { flex: 1 }, children: text }), _jsx(Tooltip, { title: 'Sao ch\u00E9p', children: _jsx(CopyOutlined, { onClick: (e) => {
                        e.stopPropagation();
                        handleCopy(text);
                    } }) })] }));
    const customOptions = options?.map((opt) => ({
        ...opt,
        label: isCopy && opt?.label ? renderLabelWithCopy(String(opt?.label)) : opt.label,
        object: opt?.object
    }));
    const selectElement = (_jsx(Select, { ...rest, className: `${className || ''} ${readOnly ? 'borderless-select' : ''} `, mode: isMultiSelect ? 'multiple' : undefined, showSearch: true, ...(openProp !== undefined ? { open: readOnly ? false : openProp } : { open: readOnly ? false : openState }), onDropdownVisibleChange: handleDropdownVisibleChange, disabled: props.disabled || readOnly, bordered: !readOnly, filterOption: simpleSearchFilter, options: customOptions, onChange: handleSelectChange, placeholder: props.disabled || readOnly ? ' ' : placeholder || `Chọn ${label?.toLowerCase() || ''}`, popupMatchSelectWidth: popupMatchSelectWidth, optionLabelProp: 'label', allowClear: allowClear, ...{
            onMouseDownCapture: (e) => {
                if (e.button === 2) {
                    // Chuột phải - chặn event trước khi AntD xử lý
                    e.stopPropagation();
                    if (e.nativeEvent && typeof e.nativeEvent.stopImmediatePropagation === 'function') {
                        e.nativeEvent.stopImmediatePropagation();
                    }
                }
            },
            onClickCapture: (e) => {
                if (e.button === 2) {
                    // Chuột phải - chặn click event
                    e.stopPropagation();
                    if (e.nativeEvent && typeof e.nativeEvent.stopImmediatePropagation === 'function') {
                        e.nativeEvent.stopImmediatePropagation();
                    }
                    e.preventDefault(); // chặn dropdown
                }
            }
        } }));
    return (_jsx(Col, { ...colProps, onContextMenu: (e) => {
            e.preventDefault();
        }, children: _jsxs(Form.Item, { label: isRow ? undefined : label ? _jsx("span", { style: { fontWeight: 600 }, children: label }) : undefined, ...(name ? { name } : {}), rules: validationRules, hidden: hidden, className: className, wrapperCol: !isRow ? { span: 24 } : undefined, style: !isRow ? { padding: 0, marginBottom: 10, ...style } : undefined, children: [isRow && !!label ? (_jsxs("div", { style: readOnly && isRow ? {} : { display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }, children: [_jsxs("label", { style: {
                                minWidth: '20%',
                                fontWeight: 500,
                                marginBottom: 0,
                                whiteSpace: 'nowrap'
                            }, children: [label, isRequired && !!label && _jsx("span", { style: { color: 'red' }, children: " *" })] }), selectElement] })) : (selectElement), isError && errorMessage && (_jsx("div", { className: 'text-danger mt-1', children: _jsx("small", { children: errorMessage }) }))] }) }));
};
